module.exports = __webpack_public_path__ + "static/media/leadsIcon.57529d76.svg";